export const ADMIN_ROUTE = '/admin';
export const LOGIN_ROUTE = '/login';
export const REGISTRATION_ROUTE = '/registration';
export const SHOP_ROUTE = '/';
export const BASKET_ROUTE = '/basket';
export const DEVICE_ROUTE = '/device';
export const TERMS_ROUTE = '/terms-of-service';
export const PRIVACY_ROUTE = '/privacy-policy';
export const RETURN_ROUTE = '/return-policy';
export const SHIPPING_ROUTE = "/shipping-policy";
export const COOKIE_ROUTE = "/cookie-policy"; 
export const COURIER_ROUTE = "/courier-policy"; 
